import React from 'react';
import { useProductQuantity } from '../hooks/useProductQuantity';

const AvailableQuantityContainer = () => {
	const { blockClass } = useProductQuantity();

	const renderClass = () => blockClass && `vtex-product-quantity-1-x-availableQuantityContainer--${blockClass}`;

	return (
		<div
			className={`availableQuantityContainer availableQuantityContainer--${blockClass} vtex-product-quantity-1-x-availableQuantityContainer ${renderClass()} mv4 c-muted-2 t-small`}
		>
			10 disponíveis
		</div>
	);
};

export default AvailableQuantityContainer;
